import request from '@/utils/request'
import type { CurrentUser, LoginPayload } from '@/types/auth'
import { delay } from '@/mock/utils'

const useMock = import.meta.env.VITE_USE_MOCK === 'true'

// 区域账号用户名 -> 区域信息映射（对应 mock/data/area.ts 中已配置账号的区域）
const AREA_ACCOUNT_MAP: Record<string, { areaId: number; areaLevel: 1 | 2 | 3; areaName: string }> = {
  building1: { areaId: 1, areaLevel: 1, areaName: '一号楼' },
  b1_floor1: { areaId: 11, areaLevel: 2, areaName: '一号楼 / 1层' },
  b2_floor1: { areaId: 21, areaLevel: 2, areaName: '二号楼 / 1层' },
  room_101: { areaId: 111, areaLevel: 3, areaName: '一号楼 / 1层 / 101室' },
}

export function login(payload: LoginPayload): Promise<{ token: string; user: CurrentUser }> {
  if (useMock) {
    if (!payload.username || !payload.password) {
      return Promise.reject(new Error('用户名或密码不能为空'))
    }
    const isOrg = payload.accountType === 'organization'
    // 用户名为admin时，标记为超级管理员，可管理所有区域账号和查看全部床位
    const isSuperAdmin = payload.username === 'admin'
    const areaAccount = AREA_ACCOUNT_MAP[payload.username]

    return delay({
      token: `mock-token-${Date.now()}`,
      user: {
        id: 1,
        username: payload.username,
        realName: isOrg ? '机构管理员' : '个人用户',
        role: isOrg ? 'org_admin' : 'user',
        accountType: payload.accountType,
        userAccountType: isSuperAdmin ? 'admin' : 'area',
        areaId: areaAccount?.areaId,
        areaLevel: areaAccount?.areaLevel,
        areaName: areaAccount?.areaName,
      },
    })
  }
  return request.post('/auth/login', payload)
}

export function fetchCurrentUser(): Promise<CurrentUser> {
  if (useMock) {
    return delay({
      id: 1,
      username: 'admin',
      realName: '管理员',
      role: 'admin',
      accountType: 'organization',
      userAccountType: 'admin',
    })
  }
  return request.get('/auth/me')
}
